// Shared Razorpay Checkout loader. One script-loading promise across the app
// so duplicate <script> tags are never inserted.
const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let razorpayScriptPromise = null;

export function loadRazorpay() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.Razorpay) return Promise.resolve(true);
  if (razorpayScriptPromise) return razorpayScriptPromise;

  razorpayScriptPromise = new Promise((resolve) => {
    const existingScript = document.querySelector(
      `script[src="${RAZORPAY_SRC}"]`
    );
    const script = existingScript || document.createElement("script");

    const cleanup = () => {
      script.removeEventListener("load", onLoad);
      script.removeEventListener("error", onError);
    };
    const onLoad = () => {
      cleanup();
      resolve(Boolean(window.Razorpay));
    };
    const onError = () => {
      cleanup();
      if (script.parentNode) script.parentNode.removeChild(script);
      razorpayScriptPromise = null;
      resolve(false);
    };

    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);

    if (!existingScript) {
      script.src = RAZORPAY_SRC;
      script.async = true;
      script.dataset.razorpayCheckout = "true";
      document.body.appendChild(script);
    } else if (window.Razorpay) {
      cleanup();
      resolve(true);
    }
  });

  return razorpayScriptPromise;
}
